import apiClient from '@/api/apiClient';
import { handleError, getAuthData, prepareModel, validateId } from '../../utils/storeHelpers';

export default {
  namespaced: true,
  state: {
    schema: {},
    dataCrud: [],
    isNewRecord: true,
    status: '',
  },

  getters: {
    schema: (state) => state.schema,
    dataCrud: (state) => state.dataCrud,
    isNewRecord: (state) => state.isNewRecord,
    status: (state) => state.status,
  },

  mutations: {
    SET_SCHEMA(state, schema) {
      state.schema = schema;
    },
    SET_RECORDS(state, { recordsData }) {
      state.dataCrud = Array.isArray(recordsData?.dataCrud) ? recordsData.dataCrud : [];
      state.isNewRecord = Boolean(recordsData?.isNewRecord);
    },
    SET_STATUS(state, status) {
      state.status = status;
    },
  },

  actions: {
    async fetchSchema({ commit }) {
      try {
        commit('SET_STATUS', 'loading');
        const responses = await Promise.all([
          apiClient.anxACxCriminalSchema(),
          apiClient.catCrime(),
          apiClient.catCrimeType(),
          apiClient.catAgeInterval(),
          apiClient.catCrimeWeapon(),
          apiClient.catCrimeIntervention(),
          apiClient.catDuration(),
          apiClient.catBond(),
        ]);
        const [
          schemaRes,
          catCrime,
          catCrimeType,
          catAgeInterval,
          catCrimeWeapon,
          catCrimeIntervention,
          catDuration,
          catBond,
        ] = responses.map((res) => res?.data ?? {});

        const catDurationAdjusted1 = (catDuration.data ?? []).slice(77);

        if (!schemaRes.formCrud) throw new Error('Estructura de schema inválida.');

        const schema = structuredClone(schemaRes);
        schema.formCrud.back_crime_code.items = catCrime.data ?? [];
        schema.formCrud.back_crime_type_id.items = catCrimeType.data ?? [];
        schema.formCrud.back_crime_age_id.items = catAgeInterval.data ?? [];
        schema.formCrud.back_crime_weapon_id.items = catCrimeWeapon.data ?? [];
        schema.formCrud.back_crime_intervention_id.items = catCrimeIntervention.data ?? [];
        schema.formCrud.back_crime_intervention_duration_id.items = catDurationAdjusted1;
        schema.formCrud.i1_back_crime_victim_bond_id.items = catBond.data ?? [];
        schema.formCrud.i2_back_crime_victim_bond_id.items = catBond.data ?? [];
        schema.formCrud.i3_back_crime_victim_bond_id.items = catBond.data ?? [];
        schema.formCrud.i4_back_crime_victim_bond_id.items = catBond.data ?? [];
        schema.formCrud.i5_back_crime_victim_bond_id.items = catBond.data ?? [];
        schema.formCrud.i6_back_crime_victim_bond_id.items = catBond.data ?? [];

        commit('SET_SCHEMA', schema);
      } catch (error) {
        handleError(error, commit);
      }
    },

    async fetchRecords({ commit, rootState }) {
      try {
        const { clinicalHistories_id, institutions_profes_id } = getAuthData(rootState);        
        const res = await apiClient.modelANxACxCriminal(clinicalHistories_id, institutions_profes_id);
        const recordsData = res?.data?.data ?? [];
        commit('SET_RECORDS', { recordsData });
        commit('SET_STATUS', 'loaded');
      } catch (error) {
        handleError(error, commit);
      }
    },

    async createRecord({ commit, rootState }, { model }) {
      try {
        commit('SET_STATUS', 'create');
        const preparedModel = prepareModel(rootState, model);
        await apiClient.createANxACxCriminal(preparedModel);
        commit('SET_STATUS', 'success');
      } catch (error) {
        handleError(error, commit);
      }
    },

    async updateRecord({ commit, rootState }, { model }) {
      try {
        commit('SET_STATUS', 'update');
        const { clinicalHistories_id } = getAuthData(rootState);
        const preparedModel = prepareModel(rootState, model);
        await apiClient.updateANxACxCriminal(clinicalHistories_id, preparedModel);
        commit('SET_STATUS', 'success');
      } catch (error) {
        handleError(error, commit);
      }
    },

    async removeRecord({ commit, rootState }, { id }) {
      try {
        commit('SET_STATUS', 'remove');
        const { clinicalHistories_id, institutions_profes_id } = getAuthData(rootState);
        validateId(id);
        await apiClient.deleteANxACxCriminal(id, clinicalHistories_id, institutions_profes_id);
        commit('SET_STATUS', 'success');
      } catch (error) {
        handleError(error, commit);
      }
    },
  },
};
